import { useNavigate } from "react-router-dom";

const IPhoneDuoBanner = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col justify-between items-center w-full h-full bg-[#FFF] text-black pt-4">
      {/* Nội dung trên */}
      <div className="flex flex-col text-center gap-2 px-4 items-center">
        <p className="text-3xl lg:text-2xl font-bold">iPhone Duo</p>
        <p className="text-md lg:text-3xl text-gray-600 hidden lg:block">
          Màn hình iPhone lớn nhất từng có. Trong một thiết kế gập thanh nhã.
        </p>
        <div className="flex flex-col lg:hidden">
          <p className="text-md lg:text-3xl text-gray-600 lg:hidden">
            Màn hình iPhone lớn nhất từng có
          </p>
          <p className="text-md lg:text-3xl text-gray-600 lg:hidden">
            Trong một thiết kế gập thanh nhã.{" "}
          </p>
        </div>
        <button
          onClick={() => navigate(`/products/iPhone/iphone-duo`)}
          className="w-28 py-2 bg-black text-white rounded-md hover:bg-gray-800 transition my-2 lg:my-4"
        >
          Mua ngay
        </button>
      </div>

      {/* Hình ảnh minh họa */}
      <div className="w-auto h-full overflow-hidden">
        {/* Mobile: < lg */}
        <video
          id="welcome-video-mobile"
          aria-label="iPhone 17 Pro, màu Cam Vũ Trụ…"
          className="block lg:hidden w-full h-full object-cover object-[center_30%]"
          muted
          playsInline
          autoPlay
          loop
          preload="none"
          poster="https://res.cloudinary.com/dyxwbtohw/image/upload/v1789375538/hero_endframe__gdt3l3spaqie_small_2x_lieo2i.jpg"
        >
          <source
            src="https://res.cloudinary.com/dyxwbtohw/video/upload/v1789375305/small_2x_1_thwmns.mp4"
            type="video/mp4"
          />
        </video>

        {/* Desktop: >= lg */}
        <video
          id="welcome-video-desktop"
          aria-label="iPhone 17 Pro, màu Cam Vũ Trụ…"
          className="hidden lg:block w-full h-full object-cover object-[center_30%]"
          muted
          playsInline
          autoPlay
          loop
          preload="none"
          poster="https://res.cloudinary.com/dyxwbtohw/image/upload/v1789375538/hero__dbnzxlb3ia2q_medium_2x_fxaipm.jpg"
        >
          <source
            src="https://res.cloudinary.com/dyxwbtohw/video/upload/v1789375305/medium_2x_1_f4ukip.mp4"
            type="video/mp4"
          />
        </video>
      </div>
    </div>
  );
};
export default IPhoneDuoBanner;
